import { useState } from "react";
import { LegalModal } from "@/components/LegalModal";

/* SalesFooter — Rodapé com links legais abrindo modais com conteúdo real dos documentos */
export const SalesFooter = () => {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  return (
    <>
      <footer className="border-t border-border bg-card/30 py-10 sm:py-14">
        <div className="container max-w-6xl mx-auto px-4">

          {/* Top: logo + descrição + links */}
          <div className="flex flex-col md:flex-row justify-between gap-6 sm:gap-8 mb-8 sm:mb-10">
            {/* Logo + tagline */}
            <div className="max-w-xs mx-auto md:mx-0 text-center md:text-left">
              <div className="flex items-center gap-3 mb-3">
                <div className="bg-gradient-to-br from-accent to-primary rounded-xl w-9 h-9 flex items-center justify-center text-accent-foreground font-bold text-sm shrink-0">
                  JO
                </div>
                <span className="font-bold text-foreground">Jornada Oncológica na Prática</span>
              </div>
              <p className="text-xs text-muted-foreground leading-relaxed">
                A plataforma de consulta clínica para enfermeiros oncológicos. Protocolos, calculadoras e guias — online, no celular, no plantão.
              </p>
            </div>

            {/* Links */}
            <div className="flex flex-wrap gap-x-10 sm:gap-x-12 gap-y-5 sm:gap-y-6 justify-center md:justify-start">
              <div>
                <p className="text-xs font-semibold text-foreground uppercase tracking-widest mb-3">Suporte</p>
                <ul className="space-y-2">
                  <li>
                    <a
                      href="https://wa.me/5534999168887"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm text-muted-foreground hover:text-accent cursor-pointer transition-colors underline-offset-2 hover:underline flex items-center gap-1.5"
                    >
                      💬 Falar no WhatsApp
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/portacathenf/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm text-muted-foreground hover:text-accent cursor-pointer transition-colors underline-offset-2 hover:underline flex items-center gap-1.5"
                    >
                      📸 Instagram
                    </a>
                  </li>
                </ul>
              </div>
              <div>
                <p className="text-xs font-semibold text-foreground uppercase tracking-widest mb-3">Legal</p>
                <ul className="space-y-2">
                  <li>
                    <span
                      onClick={() => setShowPrivacy(true)}
                      className="text-sm text-muted-foreground hover:text-accent cursor-pointer transition-colors underline-offset-2 hover:underline"
                    >
                      Política de Privacidade
                    </span>
                  </li>
                  <li>
                    <span
                      onClick={() => setShowTerms(true)}
                      className="text-sm text-muted-foreground hover:text-accent cursor-pointer transition-colors underline-offset-2 hover:underline"
                    >
                      Termos de Uso
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="border-t border-border pt-5 sm:pt-6">
            <div className="flex flex-col md:flex-row justify-between items-center gap-2 sm:gap-3">
              <p className="text-xs text-muted-foreground text-center md:text-left max-w-xl">
                Este material é de apoio educacional. As condutas devem ser confirmadas com os protocolos institucionais e equipe médica. Não substitui avaliação clínica.
              </p>
              <p className="text-xs text-muted-foreground shrink-0">
                © 2026 Jornada Oncológica na Prática. Todos os direitos reservados.
              </p>
            </div>
          </div>

        </div>
      </footer>

      {/* ── Modal: Política de Privacidade ── */}
      <LegalModal
        isOpen={showPrivacy}
        onClose={() => setShowPrivacy(false)}
        title="Política de Privacidade – Projeto Enfermeiro Onco-Expert"
      >
        <p className="text-xs text-accent mb-4">Última Atualização: 03 de Agosto de 2025</p>
        <p>Esta Política de Privacidade descreve como o Projeto Enfermeiro Onco-Expert coleta, usa, armazena e protege as informações pessoais dos usuários que acessam e utilizam nossos serviços. A sua privacidade é de extrema importância para nós, e estamos comprometidos em proteger seus dados pessoais em conformidade com a Lei Geral de Proteção de Dados (LGPD - Lei nº 13.709/2018) e outras leis aplicáveis.</p>

        <h3 className="text-foreground font-semibold mt-5 mb-2">1. Informações que Coletamos</h3>
        <p><strong className="text-foreground">1.1. Informações Pessoais Fornecidas por Você:</strong></p>
        <p>Dados de Cadastro: Nome completo, e-mail, telefone, CPF (para emissão de nota fiscal e certificado), endereço.</p>
        <p>Dados de Pagamento: Informações relacionadas a transações de compra (não armazenamos dados completos de cartão de crédito, que são processados por gateways de pagamento seguros).</p>
        <p>Comunicações: Informações que você nos fornece ao entrar em contato conosco.</p>
        <p><strong className="text-foreground">1.2. Informações Coletadas Automaticamente:</strong></p>
        <p>Dados de Navegação: Endereço IP, tipo de navegador, sistema operacional, páginas visitadas, tempo de permanência.</p>
        <p>Cookies e Tecnologias Semelhantes: Utilizamos cookies essenciais, de desempenho, funcionalidade e publicidade.</p>

        <h3 className="text-foreground font-semibold mt-5 mb-2">2. Como Usamos Suas Informações</h3>
        <p>Utilizamos as informações para: fornecimento de serviços, processamento de pagamentos, comunicação, personalização da experiência, melhoria dos serviços, segurança e conformidade legal — sempre com base nas justificativas legais previstas na LGPD.</p>

        <h3 className="text-foreground font-semibold mt-5 mb-2">3. Compartilhamento de Informações</h3>
        <p>Não vendemos, alugamos ou trocamos suas informações pessoais com terceiros para fins de marketing. Podemos compartilhar com provedores de serviços (gateways de pagamento, e-mail marketing, hospedagem), quando exigido por lei ou para proteção de direitos.</p>

        <h3 className="text-foreground font-semibold mt-5 mb-2">4. Seus Direitos (LGPD)</h3>
        <p>Você tem direito a: confirmação, acesso, retificação, anonimização/bloqueio/eliminação, portabilidade, informação, revogação do consentimento e oposição ao tratamento de dados.</p>
        <p>Para exercer seus direitos, entre em contato: <span className="text-accent">arturcunha2025@gmail.com</span></p>

        <h3 className="text-foreground font-semibold mt-5 mb-2">5. Segurança dos Dados</h3>
        <p>Implementamos medidas de segurança técnicas e organizacionais adequadas para proteger suas informações contra acesso não autorizado, alteração, divulgação ou destruição.</p>

        <h3 className="text-foreground font-semibold mt-5 mb-2">6. Retenção de Dados</h3>
        <p>Dados de cadastro e pagamento: mantidos por 5 anos após a transação. Dados de navegação: 12 meses. Após o término, os dados serão eliminados ou anonimizados.</p>

        <h3 className="text-foreground font-semibold mt-5 mb-2">7. Links para Sites de Terceiros</h3>
        <p>Nosso site pode conter links para sites de terceiros. Esta Política não se aplica a esses sites.</p>

        <h3 className="text-foreground font-semibold mt-5 mb-2">8. Alterações a Esta Política</h3>
        <p>Podemos atualizar esta Política periodicamente. Quaisquer alterações serão publicadas nesta página com a data da última atualização.</p>

        <h3 className="text-foreground font-semibold mt-5 mb-2">9. Encarregado de Dados (DPO)</h3>
        <p>Para dúvidas sobre proteção de dados: <span className="text-accent">arturcunha2025@gmail.com</span></p>

        <h3 className="text-foreground font-semibold mt-5 mb-2">10. Contato</h3>
        <p>Dúvidas sobre esta Política: <span className="text-accent">arturcunha2025@gmail.com</span></p>
      </LegalModal>

      {/* ── Modal: Termos de Uso ── */}
      <LegalModal
        isOpen={showTerms}
        onClose={() => setShowTerms(false)}
        title="Termos de Uso – Projeto Enfermeiro Onco-Expert"
      >
        <p>Bem-vindo(a) ao Projeto Enfermeiro Onco-Expert! Estes Termos de Uso regem o seu acesso e uso dos serviços e conteúdos oferecidos pelo Projeto Enfermeiro Onco-Expert, proprietário Artur Rodrigues Cunha. Ao acessar ou utilizar nossos Serviços, você concorda em cumprir e estar vinculado(a) a estes Termos.</p>

        <h3 className="text-foreground font-semibold mt-5 mb-2">1. Aceitação dos Termos</h3>
        <p>Ao se registrar, acessar ou utilizar qualquer um dos Serviços, você declara ter lido, compreendido e aceito estes Termos de Uso em sua totalidade. A utilização também está sujeita à nossa Política de Privacidade, que é parte integrante e indissociável destes Termos.</p>

        <h3 className="text-foreground font-semibold mt-5 mb-2">2. Objeto dos Serviços</h3>
        <p>O Projeto Enfermeiro Onco-Expert dedica-se a oferecer cursos online, materiais educativos e recursos de capacitação profissional na área de enfermagem oncológica, com o objetivo de aprimorar o conhecimento e as habilidades de enfermeiros, estudantes e outros profissionais de saúde.</p>

        <h3 className="text-foreground font-semibold mt-5 mb-2">3. Cadastro e Conta de Usuário</h3>
        <p>Para acessar certos Serviços, você pode precisar criar uma conta de usuário, fornecendo informações precisas, completas e atualizadas. Você é responsável por manter a confidencialidade de suas credenciais de acesso e por todas as atividades que ocorram em sua conta.</p>

        <h3 className="text-foreground font-semibold mt-5 mb-2">4. Direitos de Propriedade Intelectual</h3>
        <p>Todo o conteúdo disponibilizado nos Serviços é de propriedade exclusiva do Projeto Enfermeiro Onco-Expert ou de seus licenciadores. A utilização do conteúdo é estritamente para fins pessoais e não comerciais. É proibida a reprodução, distribuição, modificação ou qualquer outra forma de exploração comercial sem prévia autorização por escrito.</p>

        <h3 className="text-foreground font-semibold mt-5 mb-2">5. Conduta do Usuário</h3>
        <p>Ao utilizar os Serviços, você concorda em não: violar leis aplicáveis; compartilhar credenciais de acesso com terceiros; interferir no funcionamento dos Serviços; tentar obter acesso não autorizado; fornecer informações falsas; tentar burlar mecanismos de segurança; utilizar os serviços para fins de concorrência desleal.</p>

        <h3 className="text-foreground font-semibold mt-5 mb-2">6. Pagamento e Reembolso</h3>
        <p>O acesso a determinados cursos pode exigir pagamento de taxas. Em conformidade com o Código de Defesa do Consumidor (Lei nº 8.078/90), o Usuário poderá exercer o direito de arrependimento no prazo de 7 (sete) dias corridos, contados da data da compra ou do início da disponibilização do acesso ao conteúdo.</p>

        <h3 className="text-foreground font-semibold mt-5 mb-2">7. Isenção de Garantias e Limitação de Responsabilidade</h3>
        <p>Os Serviços são fornecidos "como estão" e "conforme disponíveis", sem garantias de qualquer tipo. O Projeto Enfermeiro Onco-Expert não garante que os Serviços serão ininterruptos, livres de erros ou seguros.</p>

        <h3 className="text-foreground font-semibold mt-5 mb-2">8. Modificações dos Termos</h3>
        <p>O Projeto Enfermeiro Onco-Expert reserva-se o direito de modificar estes Termos a qualquer momento. As alterações entrarão em vigor após 15 (quinze) dias corridos da publicação ou notificação.</p>

        <h3 className="text-foreground font-semibold mt-5 mb-2">9. Rescisão</h3>
        <p>O Projeto Enfermeiro Onco-Expert pode rescindir ou suspender seu acesso aos Serviços imediatamente, sem aviso prévio, a nosso exclusivo critério, por qualquer motivo, incluindo violação destes Termos.</p>

        <h3 className="text-foreground font-semibold mt-5 mb-2">10. Lei Aplicável e Foro</h3>
        <p>Estes Termos serão regidos pelas leis da República Federativa do Brasil. Qualquer disputa será submetida à jurisdição exclusiva dos tribunais da Comarca de Maceió, Alagoas, Brasil.</p>

        <h3 className="text-foreground font-semibold mt-5 mb-2">11. Contato</h3>
        <p>Dúvidas sobre estes Termos: <span className="text-accent">arturcunha2025@gmail.com</span></p>

        <h3 className="text-foreground font-semibold mt-5 mb-2">12. Disposições Gerais</h3>
        <p>Se qualquer disposição destes Termos for considerada inválida, as demais permanecerão em pleno vigor. Estes Termos, juntamente com a Política de Privacidade, constituem o acordo integral entre o Usuário e o Projeto Enfermeiro Onco-Expert.</p>
      </LegalModal>
    </>
  );
};
